'use client';
import { jsx } from 'react/jsx-runtime';
import { omitThemingProps } from '@chakra-ui/styled-system';
import { ListStylesProvider } from './list-context.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { useMultiStyleConfig } from '../system/use-style-config.mjs';
import { chakra } from '../system/factory.mjs';

const ListRoot = forwardRef(
  function ListRoot2(props, ref) {
    const styles = useMultiStyleConfig("List", props);
    const { styleType, stylePosition, ...rest } = omitThemingProps(props);
    return /* @__PURE__ */ jsx(ListStylesProvider, { value: styles, children: /* @__PURE__ */ jsx(
      chakra.ul,
      {
        ref,
        role: "list",
        __css: {
          listStyleType: styleType,
          listStylePosition: stylePosition,
          ...styles.root
        },
        ...rest
      }
    ) });
  }
);
ListRoot.displayName = "List";

export { ListRoot };
